import { State } from '../../types';

export const newHampshire: State = {
  name: 'New Hampshire',
  abbreviation: 'NH',
  terms: [
    {
      word: 'Amoskeag',
      phonetic: 'am-uh-skayg',
      // audioUrl: '/audio/amoskeag.mp3',
      description: 'Derived from the Pennacook word "Namoskeag," meaning "good fishing place." Refers to the Amoskeag Falls on the Merrimack River in Manchester.'
    },
    {
      word: 'Ashuelot',
      phonetic: 'ash-wee-luht',
      // audioUrl: '/audio/ashuelot.mp3',
      description: 'A river in southwestern New Hampshire, tributary of the Connecticut River.'
    },
    {
      word: 'Belknap',
      phonetic: 'bel-nap',
      // audioUrl: '/audio/belknap.mp3',
      description: 'A county in New Hampshire, home to towns like Laconia and Belmont.'
    },
    {
      word: 'Berlin',
      phonetic: 'BURR-lin',
      // audioUrl: '/audio/berlin.mp3',
      description: 'A city in Coös County, pronounced differently from the German capital.'
    },
    {
      word: 'Boscawen',
      phonetic: 'BOS-ca-win',
      // audioUrl: '/audio/boscawen.mp3',
      description: 'A town in Merrimack County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Chocorua',
      phonetic: 'shoh-kor-oh-wah',
      // audioUrl: '/audio/chocorua.mp3',
      description: 'A prominent summit in the White Mountains, known for its scenic beauty.'
    },
    {
      word: 'Concord',
      phonetic: 'KON-kerd',
      audioUrl: '/audio/concord.mp3',
      description: 'Capital city of New Hampshire'
    },
    {
      word: 'Contoocook',
      phonetic: 'con-tuk-uk',
      // audioUrl: '/audio/contoocook.mp3',
      description: 'A village within the town of Hopkinton in Merrimack County.'
    },
    {
      word: 'Kancamagus',
      phonetic: 'kaynk-uh-mah-guhs',
      // audioUrl: '/audio/kancamagus.mp3',
      description: 'Refers to the Kancamagus Highway, a scenic route in the White Mountains.'
    },
    {
      word: 'Lebanon',
      phonetic: 'LEHB-uh-nuhn',
      // audioUrl: '/audio/lebanon.mp3',
      description: 'A city in Grafton County, pronounced differently from the Middle Eastern country.'
    },
    {
      word: 'Lyndeborough',
      phonetic: 'LYND-bur-oh',
      // audioUrl: '/audio/lyndeborough.mp3',
      description: 'A town in Hillsborough County, often mispronounced by outsiders.'
    },
    {
      word: 'Pemigewasset',
      phonetic: 'pehm-ih-juh-wah-seht',
      // audioUrl: '/audio/pemigewasset.mp3',
      description: 'Known locally as "The Pemi," this river flows beneath the Blair Covered Bridge.'
    },
    {
      word: 'Penacook',
      phonetic: 'pehn-uh-kuk',
      // audioUrl: '/audio/penacook.mp3',
      description: 'A community within the city of Concord, originally called "Fisherville."'
    },
    {
      word: 'Piscataqua',
      phonetic: 'pih-skat-uh-kwaw',
      // audioUrl: '/audio/piscataqua.mp3',
      description: 'A river forming part of the boundary between New Hampshire and Maine.'
    },
    {
      word: 'Plaistow',
      phonetic: 'PLAH-stow',
      // audioUrl: '/audio/plaistow.mp3',
      description: 'A town in Rockingham County, pronounced with a silent "i."'
    },
    {
      word: 'Sanbornton',
      phonetic: 'San-BORN-tuhn',
      // audioUrl: '/audio/sanbornton.mp3',
      description: 'A town in Belknap County, often mispronounced due to its spelling.'
    },
    {
      word: 'Stratham',
      phonetic: 'STRA-tuhm',
      // audioUrl: '/audio/stratham.mp3',
      description: 'A town in Rockingham County, pronounced with a silent "h."'
    },
    {
      word: 'Winnipesaukee',
      phonetic: 'wihn-uh-puh-sawkee',
      // audioUrl: '/audio/winnipesaukee.mp3',
      description: 'The largest lake in New Hampshire, a popular tourist destination.'
    }
  ]
};